// The /team-and-agents roster order (WL-7, persona audit round 1, tomas; Nika
// 2026-10-25 21:20: "Own agents, platform ones labeled").
//
// A workspace's OWN agents are the ones with an agent row in its org (the
// roster's Mongo identity: `userId`). A seed agent with no row there is a
// PLATFORM default (s1m0ne, Chuvak, Temo …): the page still shows it — it can
// be activated into the org — but after the workspace's own agents and marked
// `platform: true`, so the canvas draws it under the "Platform" label.
//
// A row the PLATFORM made is built in too, row or not (persona round 5, tomas:
// a new workspace listed Personal Assistant, Simone and Temo as his own). The
// server's org seeder stamps its defaults into every team org, and the
// canvas's "Activate agents" provisions the seeds; both key the row by its
// `seedSlug`. So a row with a seedSlug stays in the platform block — it keeps
// its `userId`, so it stays assignable and chainable. Only an agent the org
// made itself (a row with no seedSlug) is the workspace's own.
//
// Pure: no state, no element. The relative order inside each group is kept.
export const canvasAgentRoster = (agents) => {
  const list = Array.isArray(agents) ? agents : []
  const own = []
  const platform = []
  for (const a of list) {
    if (!a || typeof a !== 'object') continue
    const seeded = a.seedSlug != null && a.seedSlug !== ''
    if (a.userId != null && a.userId !== '' && !seeded) {
      own.push(a.platform ? { ...a, platform: false } : a)
    } else {
      platform.push(a.platform === true ? a : { ...a, platform: true })
    }
  }
  return own.concat(platform)
}

// Is this the canvas's OWN roster shape? Two other surfaces write the root
// `_agents` key and claim the same `_agentsLoaded` gate: the home roster and
// the Simone composer (shared ensureAgentRoster). They write a LEAN list — no
// seed join, no caption, no platform split — and the canvas painted it raw
// ("Simone", caption "Agent", no Platform label). Every row the canvas makes
// carries a caption bundle key, so a list where each row has one is the
// canvas's; anything else is not, and the canvas loads its own.
export const canvasRosterShaped = (agents) =>
  Array.isArray(agents) &&
  agents.length > 0 &&
  agents.every((a) => a && typeof a === 'object' && typeof a.caption === 'string' && !!a.caption)

// The platform agents of a roster, in roster order.
export const canvasPlatformAgents = (agents) =>
  (Array.isArray(agents) ? agents : []).filter((a) => a && a.platform === true)
